import { useState } from "react";

export default function SubscribeBanner() {
  const [value, setValue] = useState("");
  const [message, setMessage] = useState("");

  const handleSubscribe = () => {
    if (!value.trim()) {
      setMessage("请先填写邮箱或手机号");
      return;
    }
    setMessage("演示环境：订阅提醒功能暂未接入，感谢关注 51cg5");
    setValue("");
  };

  return (
    <section className="w-full bg-background-100">
      <div className="mx-auto max-w-[1440px] px-4 py-12 md:px-6 md:py-16">
        <div className="overflow-hidden rounded-lg bg-gradient-to-r from-primary-500 to-accent-500">
          <div className="flex flex-col gap-6 p-6 md:flex-row md:items-center md:justify-between md:p-10">
            <div className="max-w-xl">
              <h2 className="font-heading text-xl font-black text-background-50 md:text-3xl">
                订阅 51cg5 热度追踪提醒
              </h2>
              <p className="mt-3 text-sm text-background-50/90 md:text-base">
                热门榜与热议焦点更新时，第一时间把当前最受关注的事件动态推给你。
              </p>
            </div>
            <div className="w-full md:w-auto">
              <div className="flex flex-col gap-2 sm:flex-row">
                <input
                  value={value}
                  onChange={(event) => setValue(event.target.value)}
                  placeholder="输入邮箱 / 手机号"
                  className="w-full rounded-md border border-background-50/30 bg-background-50/15 px-4 py-2.5 text-sm text-background-50 outline-none placeholder:text-background-50/70 sm:w-64"
                />
                <button
                  type="button"
                  onClick={handleSubscribe}
                  className="shrink-0 cursor-pointer whitespace-nowrap rounded-md bg-background-50 px-6 py-2.5 text-sm font-bold text-foreground-950 transition-colors hover:bg-background-200"
                >
                  立即订阅
                </button>
              </div>
              {message ? <p className="mt-2 text-xs text-background-50/90">{message}</p> : null}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}